module.exports = __webpack_public_path__ + "static/media/scroll-image.f1d2a826.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scroll-image.jpg
// module id = 20
// module chunks = 0